import { ImportTypeLob } from '@/api/admin/lob';
import { Button } from '@/components/ui/button';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns/format';
import { ArrowUpDown } from 'lucide-react';

import { UpdateImportTypeLob } from './sheet-update';

export const getColumns = (
	importTypeId: number,
): ColumnDef<ImportTypeLob>[] => [
	{
		accessorKey: 'importTypeLobId',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Import Type Lob Id
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="text-right font-medium">{row.original.importTypeLobId}</div>
			);
		},
	},
	{
		accessorKey: 'brandName',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Company Location
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.brandName}
				</div>
			);
		},
	},
	{
		accessorKey: 'lobDescription',
		header: ({ column }) => (
			<div className="flex justify-center">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Line of Business
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="flex justify-center whitespace-nowrap font-medium">
					{row.original.lobDescription}
				</div>
			);
		},
	},
	{
		accessorKey: 'numInstallments',
		header: ({ column }) => (
			<div className="text-right">
				<Button
					variant="ghost"
					onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
				>
					Number of Installments
					<ArrowUpDown />
				</Button>
			</div>
		),
		cell: ({ row }) => {
			return (
				<div className="text-right font-medium">{row.original.numInstallments}</div>
			);
		},
	},
	{
		accessorKey: 'effectiveDate',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Effective Date
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="font-medium">
					{row.original.effectiveDate
						? format(row.original.effectiveDate, 'P')
						: '---'}
				</div>
			);
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>
				{
					<UpdateImportTypeLob
						importTypeLob={row.original}
						importTypeId={importTypeId}
					/>
				}
			</div>
		),
	},
];
